import React from 'react';
import './App.css';
import { ProviderStack } from './components/meta/ProviderStack/ProviderStack';
import { Routes } from './components/meta/Routes/Routes';
import { ValueLabelWithImage } from './components/molecules/Header/Header.types';
import { Layout } from './components/templates/Layout/Layout';
import { TranslationKeys } from './locale/keys';

const pages: ValueLabelWithImage<string, TranslationKeys>[] = [
  { label: 'service.carglass', value: '/autoglas', image: 'repair' },
  { label: 'service.carfoil', value: '/autofolie', image: 'tinted' },
  { label: 'contact', value: '/kontakt', image: 'repair' },
  { label: 'approach', value: '/anfahrt', image: 'repair' },
];
export const App: React.FC = () => {
  return (
    <ProviderStack>
      <Layout pages={pages}>
        <Routes />
      </Layout>
    </ProviderStack>
  );
};

export default App;
